import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TaskShareModal = ({ isOpen, onClose, onShareTask, tasks, isLoading }) => {
  const [selectedTask, setSelectedTask] = useState(null);

  useEffect(() => {
    if (!isOpen) {
      setSelectedTask(null);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <motion.div 
        className="modal-content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>Share Task</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        
        <div className="modal-body">
          {tasks.length === 0 ? (
            <p className="no-tasks">No tasks available to share</p>
          ) : (
            <div className="tasks-list">
              {tasks.map(task => (
                <motion.div
                  key={task.id}
                  className={`task-item ${selectedTask?.id === task.id ? 'selected' : ''}`}
                  onClick={() => setSelectedTask(task)}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <div className="task-info">
                    <h3>{task.title}</h3>
                    <p>{task.description || 'No description'}</p>
                    <div className="task-meta">
                      <span className="due-date">
                        {task.dueDate ? new Date(task.dueDate).toLocaleDateString() : 'No due date'}
                      </span>
                      <span className={`status ${task.status?.toLowerCase()}`}>
                        {task.status || 'Not started'}
                      </span>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button 
            className="cancel-button" 
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="share-button"
            onClick={() => {
              if (selectedTask) {
                onShareTask(selectedTask);
              }
            }}
            disabled={!selectedTask || isLoading}
          >
            {isLoading ? 'Sharing...' : 'Share Task'}
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default TaskShareModal; 